import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { useUserStore } from "@/stores/user";
import { useCommonStore } from "@/stores/common";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Landing",
    component: () => import("../views/Landing.vue"),
    meta: {
      layout: "DefaultLayout",
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin/Index.vue"),
    meta: {
      layout: "AdminLayout",
      policy: "a",
    },
    children: [
      {
        path: "Dashboard",
        name: "admin-dashboard",
        component: () => import("../views/Admin/Dashboard.vue"),
        meta: { header: "DashBoard" },
      },
      {
        path: "General",
        name: "admin-general-params",
        component: () => import("../views/Admin/GeneralParam.vue"),
        meta: { header: "Genel Tanımlar" },
      },
      {
        path: "PaymentProvider",
        name: "admin-payment-provider",
        component: () => import("../views/Admin/PaymentProviderList.vue"),
        meta: { header: "Ödeme Sağlayıcılar" },
      },
      {
        path: "PaymentProvider/:id",
        name: "admin-payment-provider-edit",
        component: () => import("../views/Admin/PaymentProviderEdit.vue"),
        meta: { header: "Ödeme Sağlayıcı" },
      },
      {
        path: "CardBrand",
        name: "admin-Card-Brand",
        component: () => import("../views/Admin/CardBrandList.vue"),
        meta: { header: "Kart Markalar" },
      },
      {
        path: "CardType",
        name: "admin-Card-Type",
        component: () => import("../views/Admin/CardTypeList.vue"),
        meta: { header: "Kart Tipi" },
      },
      {
        path: "CardType/:id",
        name: "admin-Card-Type-edit",
        component: () => import("../views/Admin/CardTypeEdit.vue"),
        meta: { header: "Kart Tipi" },
      },
      {
        path: "CardBrand/:id",
        name: "admin-Card-Brand-edit",
        component: () => import("../views/Admin/CardBrandEdit.vue"),
        meta: { header: "Kart Marka" },
      },
      {
        path: "CardProgram",
        name: "admin-Card-Program",
        component: () => import("../views/Admin/CardProgramList.vue"),
        meta: { header: "Kart programlar" },
      },
      {
        path: "CardProgram/:id",
        name: "admin-Card-Program-Edit",
        component: () => import("../views/Admin/CardProgramEdit.vue"),
        meta: { header: "Kart Program" },
      },

      {
        path: "Company",
        name: "admin-Company",
        component: () => import("../views/Admin/CompanyList.vue"),
        meta: { header: "Firmalar" },
      },
      {
        path: "Company/:id",
        name: "admin-Company-edit",
        component: () => import("../views/Admin/CompanyEdit.vue"),
        meta: { header: "Firma" },
      },

      {
        path: "Announcement",
        name: "admin-Announcement",
        component: () => import("../views/Admin/AnnouncementList.vue"),
        meta: { header: "Duyuru / Alarm" },
      },
      {
        path: "Announcement/:id",
        name: "admin-Announcement-edit",
        component: () => import("../views/Admin/AnnouncementEdit.vue"),
        meta: { header: "Duyuru / Alarm" },
      },
      {
        path: "Package",
        name: "admin-Package",
        component: () => import("../views/Admin/PackageList.vue"),
        meta: { header: "Paketler" },
      },
      {
        path: "Package/:id",
        name: "admin-Package-edit",
        component: () => import("../views/Admin/PackageEdit.vue"),
        meta: { header: "Paketler" },
      },
      {
        path: "ExtraPackage",
        name: "admin-ExtraPackage",
        component: () => import("../views/Admin/ExtraPackageList.vue"),
        meta: { header: "Extra Paketler" },
      }
    ],
  },
  {
    path: "/kullanici",
    name: "user",
    component: () => import("../views/User/Login.vue"),
    meta: {
      layout: "UserLayout",
    },
    children: [
      {
        path: "giris",
        name: "user-login",
        component: () => import("../views/User/Login.vue"),
      },
    ],
  },
  {
    path: "/:company",
    name: "Company",
    component: () => import("../views/Company/Index.vue"),
    meta: {
      layout: "CompanyLayout",
    },
    beforeEnter: (to, from, next) => {
      if (to.matched.length && to.matched[to.matched.length - 1].path === '/:company' && (to.path === `/${to.params.company}` || to.path === `/${to.params.company}/`)) {
        next({ path: `/${to.params.company}/Odeme` });
      } else {
        next();
      }
    },
    children: [
      {
        path: "giris",
        name: "company-login",
        component: () => import("../views/User/Login.vue"),
        meta: {
          layout: "UserLayout",
        },
      },
      {
        path: "sifre-sifirla/:guid",
        name: "user-reset-password",
        component: () => import("../views/User/ResetPassword.vue"),
        meta: {
          layout: "UserLayout",
        },
      },
      {
        path: "Odeme",
        name: "company-payment",
        component: () => import("../views/Payment/StartRefactoredNew.vue"),
        meta: {
          layout: "PaymentLayout",
        },
      },
      {
        path: "Sonuc/:transactionId",
        alias: "sonuc/:transactionId",
        name: "company-payment-result",
        component: () => import("../views/Payment/Result.vue"),
        meta: {
          layout: "PaymentLayout",
        },
      },
      {
        path: "/Ogrenci",
        alias: "/ogrenci",
        name: "student-payment",
        component: () => import("../views/Payment/StartRefactoredNew.vue"),
        meta: {
          layout: "HalicLayout",
        },
      },
      {
        path: "/Sonuc/:transactionId",
        alias: "/sonuc/:transactionId",
        name: "student-payment-result",
        component: () => import("../views/Payment/Result.vue"),
        meta: {
          layout: "HalicLayout",
        },
      },
      {
        path: "/UyumOdeme",
        name: "uyum-payment",
        component: () => import("../views/Payment/StartRefactoredNew.vue"),
        meta: {
          layout: "UyumLayout",
        },
      },
      {
        path: "/Sonuc/:transactionId",
        name: "uyum-payment-result",
        component: () => import("../views/Payment/Result.vue"),
        meta: {
          layout: "UyumLayout",
        },
      },
      {
        path: "/CinarOgrenci",
        name: "cinar-payment",
        component: () => import("../views/Payment/StartRefactoredNew.vue"),
        meta: {
          layout: "CinarLayout",
        },
      },
      {
        path: "/CinarOdeme",
        name: "cinar-payment-page",
        component: () => import("../views/Payment/CinarPayment.vue"),
        meta: {
          layout: "CinarLayout",
        },
      },
      {
        path: "/CinarSonuc/:transactionId",
        name: "cinar-payment-result",
        component: () => import("../views/Payment/Result.vue"),
        meta: {
          layout: "CinarLayout",
        },
      },
      // {
      //   path: "/Ogrenci",
      //   name: "student-payment",
      //   component: () => import("../views/CustomizedPayment/HalicUniversity/StartRefactored.vue"),
      //   meta: {
      //     layout: "HalicLayout",
      //   },
      // },
      // {
      //   path: "/Sonuc/:transactionId",
      //   name: "student-payment-result",
      //   component: () => import("../views/CustomizedPayment/HalicUniversity/Result.vue"),
      //   meta: {
      //     layout: "HalicLayout",
      //   },
      // },
      // {
      //   path: "Ogrenci",
      //   name: "company-payment-ogrenci",
      //   component: () => import("../views/CustomizedPayment/HalicUniversity/Start.vue"),
      //   meta: {
      //     layout: "PaymentLayout",
      //   },
      // },
      // {
      //   path: "Sonuc/:transactionId",
      //   name: "company-payment-result",
      //   component: () => import("../views/CustomizedPayment/HalicUniversity/Result.vue"),
      //   meta: {
      //     layout: "PaymentLayout",
      //   },
      // },
      // {
      //   path: "Sonuc2/:transactionId",
      //   name: "company-payment-result2",
      //   component: () => import("../views/Payment/Result2.vue"),
      //   meta: {
      //     layout: "PaymentLayout",
      //   },
      //},
      {
        path: "Dealer",
        name: "company-dealer",
        component: () => import("../views/Company/Dealer/Index.vue"),
        meta: {
          layout: "DealerLayout",
          policy: "cu",
          header: "bayi_anasayfa",
        },
        children: [
          {
            path: "Dashboard",
            name: "dealer-dashboard",
            component: () => import("../views/Company/Dealer/Dashboard.vue"),
            meta: { header: "bayi_anasayfa" },
          },
          {
            path: "AppUser",
            name: "dealer-appuser",
            component: () => import("../views/Company/Dealer/AppUserList.vue"),
            meta: { header: "kullanicilar" },
          },
          {
            path: "AppUser/:id",
            name: "dealer-appuser-edit",
            component: () => import("../views/Company/Dealer/AppUserEdit.vue"),
            meta: { header: "kullanici" },
          },
          {
            path: "Account",
            name: "dealer-appuser-account",
            component: () => import("../views/Company/Dealer/AccountList.vue"),
            meta: { header: "cari_listesi" },
          },
          {
            path: "Account/:id",
            name: "dealer-appuser-Account-edit",
            component: () => import("../views/Company/Dealer/AccountEdit.vue"),
            meta: { header: "cari" },
          },
          {
            path: "Settings",
            name: "dealer-appuser-Settings",
            component: () => import("../views/Company/Dealer/AccountSettings.vue"),
            meta: { header: "hesap_ayarlari" },
          },

          {
            path: "PaymentTemplate",
            name: "dealer-appuser-PaymentTemplate",
            component: () => import("../views/Company/Dealer/PaymentTemplateList.vue"),
            meta: { header: "odeme_linkleri" },
          },
          {
            path: "PaymentTemplate/:id",
            name: "dealer-appuser-PaymentTemplate-edit",
            component: () => import("../views/Company/Dealer/PaymentTemplateEdit.vue"),
            meta: { header: "odeme_linki" },
          },
          {
            path: "SendingLinks",
            name: "dealer-appuser-SendingLinks",
            component: () => import("../views/Company/Dealer/SendingLinks.vue"),
            meta: { header: "link_gonder" },
          },
          {
            path: "NeedToPay",
            name: "dealer-appuser-NeedToPay",
            component: () => import("../views/Company/Dealer/NeedToPay.vue"),
            meta: { header: "odemeniz_gerekenler" },
          },
          {
            path: "SentLinks",
            name: "dealer-appuser-SentLinks",
            component: () => import("../views/Company/Dealer/SentLinks.vue"),
            meta: { header: "link_gonderim_sonuclari" },
          },
          {
            path: "SentLinks/:id",
            name: "dealer-appuser-SentLinks-edit",
            component: () => import("../views/Company/Dealer/SentLinksEdit.vue"),
            meta: { header: "odeme_linki_duzenle" },
          },
          {
            path: "TransactionReport",
            name: "dealer-appuser-TransactionReport",
            component: () => import("../views/Company/Dealer/TransactionReport.vue"),
            meta: { header: "islem_raporu" },
          },
          {
            path: "ManuelTransactionReport",
            name: "dealer-appuser-ManuelTransactionReport",
            component: () => import("../views/Company/Dealer/ManuelTransactionReport.vue"),
            meta: { header: "manuel_islem_raporu" },
          },
          {
            path: "AnnouncementAndAlarm",
            name: "dealer-appuser-AnnouncementAndAlarm",
            component: () => import("../views/Company/Dealer/AnnouncementAndAlarm.vue"),
            meta: { header: "duyuru_alarm" },
          },
          {
            path: "HelpDocument",
            name: "dealer-HelpDocument",
            component: () => import("../views/Company/Dealer/HelpDocument.vue"),
            meta: { header: 'yardım_dokumanı' },
          },
        ],
      },
      {
        path: "Admin",
        name: "company-admin",
        component: () => import("../views/Company/Admin/Index.vue"),
        meta: {
          layout: "CompanyAdminLayout",
          policy: "ca",
          header: 'admin_anasayfa',
        },
        children: [
          {
            path: "Company",
            name: "company-admin-company",
            component: () => import("../views/Company/Admin/CompanyEdit.vue"),
            meta: { header: 'firma_bilgileri' },
          },

          {
            path: "Dealer",
            name: "company-admin-delaer",
            component: () => import("../views/Company/Admin/DealerList.vue"),
            meta: { header: 'bayiler' },
          },
          {
            path: "Dealer/:id",
            name: "company-admin-delaer-edit",
            component: () => import("../views/Company/Admin/DealerEdit.vue"),
            meta: { header: 'bayi' },
          },

          {
            path: "AppUser",
            name: "company-admin-appuser",
            component: () => import("../views/Company/Admin/AppUserList.vue"),
            meta: { header: 'kullanici' },
          },
          {
            path: "AppUser/:id",
            name: "company-admin-appuser-edit",
            component: () => import("../views/Company/Admin/AppUserEdit.vue"),
            meta: { header: 'kullanici_duzenle' },
          },
          {
            path: "Account",
            name: "company-admin-account",
            component: () => import("../views/Company/Admin/AccountList.vue"),
            meta: { header: 'cari_listesi' },
          },
          {
            path: "Account/:id",
            name: "company-admin-Account-edit",
            component: () => import("../views/Company/Admin/AccountEdit.vue"),
            meta: { header: 'cari' },
          },
          {
            path: "Announcement",
            name: "company-admin-Announcement",
            component: () => import("../views/Company/Admin/AnnouncementList.vue"),
            meta: { header: 'duyuru_alarm' },
          },
          {
            path: "Announcement/:id",
            name: "company-admin-Announcement-edit",
            component: () => import("../views/Company/Admin/AnnouncementEdit.vue"),
            meta: { header: 'duyuru_alarm' },
          },

          {
            path: "PaymentTemplate",
            name: "company-admin-PaymentTemplate",
            component: () => import("../views/Company/Admin/PaymentTemplateList.vue"),
            meta: { header: 'odeme_linkleri' },
          },
          {
            path: "PaymentTemplate/:id",
            name: "company-admin-PaymentTemplate-edit",
            component: () => import("../views/Company/Admin/PaymentTemplateEdit.vue"),
            meta: { header: 'odeme_linki' },
          },

          {
            path: "TrackingAccount",
            name: "company-admin-TrackingAccount",
            component: () => import("../views/Company/Admin/AccountTracking.vue"),
            meta: { header: 'cari_takip' },
          },
          {
            path: "SentLinks",
            name: "company-admin-SentLinks",
            component: () => import("../views/Company/Admin/SentLinks.vue"),
            meta: { header: 'link_gonderim_sonuclari' },
          },
          {
            path: "SentLinks/:id",
            name: "company-admin-SentLinks-edit",
            component: () => import("../views/Company/Admin/SentLinksEdit.vue"),
            meta: { header: 'odeme_linki_duzenle' },
          },
          {
            path: "Merchant",
            name: "company-admin-Merchant",
            component: () => import("../views/Company/Admin/MerchantList.vue"),
            meta: { header: 'uye_isyerleri' },
          },
          {
            path: "Merchant/:id",
            name: "company-admin-Merchant-edit",
            component: () => import("../views/Company/Admin/MerchantEdit.vue"),
            meta: { header: 'uye_isyeri' },
          },

          {
            path: "PaymentRate",
            name: "company-admin-PaymentRate",
            component: () => import("../views/Company/Admin/PaymentRateList.vue"),
            meta: { header: 'banka_maliyet' },
          },
          {
            path: "PaymentRate/:id",
            name: "company-admin-PaymentRate-edit",
            component: () => import("../views/Company/Admin/PaymentRateEdit.vue"),
            meta: { header: 'banka_maliyet' },
          },

          {
            path: "PaymentRule",
            name: "company-admin-PaymentRule",
            component: () => import("../views/Company/Admin/PaymentRuleList.vue"),
            meta: { header: 'uygulanacak_oranlar' },
          },
          {
            path: "PaymentRule/:id",
            name: "company-admin-PaymentRule-edit",
            component: () => import("../views/Company/Admin/PaymentRuleEdit.vue"),
            meta: { header: 'uygulanacak_oran' },
          },

          {
            path: "TransactionReport",
            name: "company-admin-TransactionReport",
            component: () => import("../views/Company/Admin/TransactionReport.vue"),
            meta: { header: 'islem_raporu' },
          },
          {
            path: "ManuelTransactionReport",
            name: "company-admin-ManuelTransactionReport",
            component: () => import("../views/Company/Admin/ManuelTransactionReport.vue"),
            meta: { header: 'manuel_islem_raporu' },
          },
          {
            path: "DealerReport",
            name: "company-admin-DealerReport",
            component: () => import("../views/Company/Admin/DealerReport.vue"),
            meta: { header: 'bayi_raporu' },
          },
          {
            path: "SendingLinks",
            name: "company-admin-SendingLinks",
            component: () => import("../views/Company/Admin/SendingLinks.vue"),
            meta: { header: 'link_gonder' },
          },
          {
            path: "AnnouncementAndAlarm",
            name: "company-admin-AnnouncementAndAlarm",
            component: () => import("../views/Company/Admin/AnnouncementAndAlarm.vue"),
            meta: { header: 'duyuru_alarm' },
          },
          {
            path: "HelpDocument",
            name: "company-admin-HelpDocument",
            component: () => import("../views/Company/Admin/HelpDocument.vue"),
            meta: { header: 'yardım_dokumanı' },
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

const layoutHostRestrictions: Record<string, string[]> = {
  'HalicLayout': ['halicpayment', 'halic'],
  'CinarLayout': ['cinar'],
  'UyumLayout': ['uyumsoft']
};

const blockedHostPaths: Record<string, string[]> = {
  'yurtodeme.halic.edu.tr': ['/ogrenci'],
};

router.beforeResolve(async (to, from, next) => {
  const isTestMode = false;
  const mockHost = "" as string; // Test için örnek url: "halicpayment" verya "cinarkoleji"

  let host = window.location.host.toLowerCase();
  let hostname = window.location.hostname.toLowerCase();
  if (isTestMode && mockHost) {
    host = mockHost.toLowerCase();
    hostname = mockHost.toLowerCase();
  }

  const requestedLayout = to.meta?.layout as string;

  const blockedPaths = blockedHostPaths[hostname] ?? [];
  const requestedPath = to.path.toLowerCase().replace(/\/$/, '');

  if ((isTestMode || !host.includes('localhost')) && blockedPaths.includes(requestedPath)) {
    return next({ name: "Landing" });
  }

  if ((isTestMode || !host.includes('localhost')) && layoutHostRestrictions[requestedLayout]) {
    const requiredKeywords = layoutHostRestrictions[requestedLayout];

    const institutionalKeywords = ['halicpayment', 'halic', 'cinar'];
    const isInstitutionHost = institutionalKeywords.some(keyword => host.includes(keyword));
    const isGenericHost = !isInstitutionHost;

    if (!requiredKeywords.some(keyword => host.includes(keyword))) {

      const isStandardResultPath = to.path.toLowerCase().startsWith('/sonuc/');

      if (isGenericHost && isStandardResultPath) {

      } else {

        return next({ name: "Landing" });
      }
    }
  }

  const userStore = useUserStore();
  const commonStore = useCommonStore();

  if (to.meta.policy != undefined) {
    try {
      const canView = await checkPolicy(to.meta.policy as string);
      const user = userStore.getUser;

      if (user == null) {
        await logOut();
        return next({ name: "Landing" });
      }

      if (to.meta.policy == 'ca' && user.DealerId !== 0) {
        await logOut();
        return next({ name: "Landing" });
      }

      commonStore.setLoading(0);
    } catch (error) {
      commonStore.setLoading(0);
      return next({ name: "Landing" }); //Ana sayfaya yönlendirme
    }
  }
  commonStore.setLoading(0);
  return next();
});

async function checkPolicy(policy: string) {
  if (import.meta.env.MODE === "production") {
    //todo: PROD İÇİN BURAYI AÇ!!. dev'de hmr problemine yol açıyor
    //const userSvc = new UserService();
    //const policyResult = await userSvc.checkPolicy(policy);
    // if (!policyResult.IsSuccess) return false;
  }
  return true;
}

async function logOut() {
  const userStore = useUserStore();
  userStore.setUser(null);
  router.push("/");
}

export default router;
